const stickyClass = 'is-sticky';
const TO_TOP = '72px';

const getWidth = element => {
  const computed = window.getComputedStyle(element);
  const width = element.offsetWidth;
  return `${parseInt(computed.marginLeft, 10) +
    parseInt(computed.marginRight, 10) +
    parseInt(width, 10)}px`;
};

export const sticky = (headerElement, wrapper, config = {}) => {
  let isSticky = false;
  let elX;
  let elWidth;

  const stick = () => {
    if (wrapper.scrollTop >= elX) {
      headerElement.classList.add(stickyClass);
      headerElement.style.width = elWidth;
      isSticky = true;
    } else {
      headerElement.classList.remove(stickyClass);
      headerElement.style.width = 'auto';
      isSticky = false;
    }
  };

  const recalculate = () => {
    elX = headerElement.offsetTop;
    elWidth = getWidth(wrapper);

    headerElement.style.top = config.toTop || TO_TOP;
    headerElement.style.width = isSticky ? elWidth : 'auto';
  };

  return {
    stick,
    recalculate
  };
};

export default {
  sticky
};
